// extracted by mini-css-extract-plugin
module.exports = {"selectStyle":"documentation_selectStyle__3P3qE"};